import apiService from "./ApiService"
import { createQS } from "./Utils"

export const StatusContratoEnum = {
  RASCUNHO: 'R',
  PUBLICADO: 'P'
}

export function getStatusContratoDescription(status) {
  switch (status) {
    case StatusContratoEnum.RASCUNHO: return 'Rascunho'
    case StatusContratoEnum.PUBLICADO: return 'Publicado'
  }
}

export const TipoContratoEnum = {
  NORMAL: "normal",
  SEMAFORICO: "semaforico"
}

export function getTipoContratoDescription(tipo) {
  switch (tipo) {
    case TipoContratoEnum.NORMAL: return 'Normal'
    case TipoContratoEnum.SEMAFORICO: return 'Semafórico'
  }
}

class ContratoService {
  async get(termo, idFiscal, idGestor, idEmpresa, idConsorcio, idStatus, pagina, exibirInativos) {
    try {
      const qs = createQS({ termo, idFiscal, idGestor, idEmpresa, idConsorcio, idStatus, pagina, exibirInativos: exibirInativos || undefined })
      return await apiService.get('contrato?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('contrato/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('contrato', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async update(id, data) {
    try {
      return await apiService.put('contrato/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async publish(id) {
    try {
      return await apiService.post('contrato/' + id + '/publicar')
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('contrato/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async restaurar(id) {
    try {
      return await apiService.post('contrato/' + id + '/restaurar')
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarDistribuicao(idContrato) {
    try {
      return await apiService.get('contrato/' + idContrato + '/distribuicao')
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getItems(idContrato, ate, exibirInativos) {
    try {
      const params = new URLSearchParams()
      if (ate) params.set('ate', ate.toISOString())
      if (exibirInativos) params.set('exibirInativos', 'true')
      const qs = params.toString()
      return await apiService.get('contrato/' + idContrato + '/item' + (qs ? '?' + qs : ''))
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async createItem(idContrato, data) {
    try {
      return await apiService.post(`contrato/${idContrato}/item`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateItem(idContrato, idItem, data) {
    try {
      return await apiService.put(`contrato/${idContrato}/item/${idItem}`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteItem(idContrato, idItem) {
    try {
      return await apiService.delete(`contrato/${idContrato}/item/${idItem}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async restaurarItem(idContrato, idItem) {
    return await apiService.post(`contrato/${idContrato}/item/${idItem}/restaurar`)
  }

  async restaurarGrupoItem(idContrato, idGrupo) {
    return await apiService.post(`contrato/${idContrato}/grupo-item/${idGrupo}/restaurar`)
  }

  async createGroup(idContrato, data) {
    try {
      return await apiService.post(`contrato/${idContrato}/grupo`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async updateGroup(idContrato, idGrupo, data) {
    try {
      return await apiService.put(`contrato/${idContrato}/grupo/${idGrupo}`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async deleteGroup(idContrato, idGrupo) {
    try {
      return await apiService.delete(`contrato/${idContrato}/grupo/${idGrupo}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async importarItens(idContrato, file) {
    try {
      const formData = new FormData()
      formData.append('file', file)
      return await apiService.post(`contrato/${idContrato}/importar_itens`, formData)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarAditivos(idContrato, exibirInativos) {
    try {
      const qs = exibirInativos ? '?exibirInativos=true' : ''
      return await apiService.get(`contrato/${idContrato}/aditivo${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async recuperarAditivo(idContrato, idAditivo) {
    try {
      return await apiService.get(`contrato/${idContrato}/aditivo/${idAditivo}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async criarAditivo(idContrato, data) {
    try {
      return await apiService.post(`contrato/${idContrato}/aditivo`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async alterarAditivo(idContrato, idAditivo, data) {
    try {
      return await apiService.put(`contrato/${idContrato}/aditivo/${idAditivo}`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluirAditivo(idContrato, idAditivo) {
    try {
      return await apiService.delete(`contrato/${idContrato}/aditivo/${idAditivo}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async restaurarAditivo(idContrato, idAditivo) {
    try {
      return await apiService.post(`contrato/${idContrato}/aditivo/${idAditivo}/restaurar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async excluirAditivoItem(idContrato, idAditivo, idContratoItem) {
    try {
      return await apiService.delete(`contrato/${idContrato}/aditivo/${idAditivo}/item/${idContratoItem}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async restaurarAditivoItem(idContrato, idAditivo, idContratoItem) {
    try {
      return await apiService.post(`contrato/${idContrato}/aditivo/${idAditivo}/item/${idContratoItem}/restaurar`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async recuperarLogItemAlteracao(idContrato, filtros) {
    try {
      return await apiService.post(`contrato/${idContrato}/historico`, filtros)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getLogs(tipo, idRegistro) {
    try {
      return await apiService.get(`contrato-log/${tipo}/${idRegistro}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async listarAuditoria(idContrato, tipo, idRegistro) {
    try {
      const params = new URLSearchParams({ tipo: tipo || 'contrato' })
      if (idRegistro && idRegistro !== idContrato) params.set('idRegistro', idRegistro)
      return await apiService.get(`contrato/${idContrato}/auditoria?${params.toString()}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const contratoService = new ContratoService()
export default contratoService